import React, { useImperativeHandle, useRef } from 'react';
import { DragSource, DragPreviewImage, DropTarget } from 'react-dnd';

const dragSource = {
  beginDrag: props => ({
    id: props.item,
    index: props.index
  })
};

const dropSource = {
  hover(props, monitor, component) {
    if (!component) {
      return null;
    }
    const node = component.getNode();
    if (!node) {
      return null;
    }
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    if (dragIndex === hoverIndex) {
      return;
    }

    props.updateIndex(dragIndex, hoverIndex);

    monitor.getItem().index = hoverIndex;
  }
};

const ThumbnailContainer = React.forwardRef(
  (
    {
      isDragging,
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      selectPage,
      canvasUrl,
      classes,
      thumbnail,
      item,
      style
    },
    ref
  ) => {
    const elementRef = useRef(null);
    connectDragSource(elementRef);
    connectDropTarget(elementRef);
    useImperativeHandle(ref, () => ({
      getNode: () => elementRef.current
    }));
    return connectDragSource(
      <div style={style} ref={elementRef}>
        <div
          style={{
            opacity: isDragging ? 0 : 1
          }}
          onClick={() => selectPage(item)}
          key={item}
          className="grid-item"
        >
          <DragPreviewImage connect={connectDragPreview} src={canvasUrl} />
          <div className={classes}>
            <div style={{ marginBottom: '3px' }}>{thumbnail}</div>
            <span>{`Page ${item}`}</span>
          </div>
        </div>
      </div>
    );
  }
);

export default DropTarget('thumbnail', dropSource, connect => ({
  connectDropTarget: connect.dropTarget()
}))(
  DragSource('thumbnail', dragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }))(ThumbnailContainer)
);
